export function initializeExpandableBoxes() {
    document.querySelectorAll('.expandable-box').forEach(box => {
        box.addEventListener('click', function() {
            if (!this.classList.contains('show')) {
                document.querySelectorAll('.expandable-box').forEach(otherBox => {
                    if (otherBox !== this) {
                        otherBox.classList.add('d-none');
                    }
                });
                this.classList.add('show');
                document.querySelectorAll('.expandable-detail').forEach(detail => {
                    detail.classList.remove('d-none');
                });
                document.querySelectorAll('.expandable-collapse-button').forEach(button => {
                    button.classList.remove('d-none');
                });
                document.querySelectorAll('.expandable-expand-icon').forEach(icon => {
                    icon.classList.add('d-none');
                });
            }
        });
    });

    document.querySelectorAll('.expandable-collapse-button').forEach(button => {
        button.addEventListener('click', function(event) {
            document.querySelectorAll('.expandable-box').forEach(box => {
                box.classList.remove('show');
                box.classList.remove('d-none');
            });
            document.querySelectorAll('.expandable-detail').forEach(detail => {
                detail.classList.add('d-none');
            });
            document.querySelectorAll('.expandable-collapse-button').forEach(button => {
                button.classList.add('d-none');
            });
            document.querySelectorAll('.expandable-expand-icon').forEach(icon => {
                icon.classList.remove('d-none');
            });
            event.stopPropagation();
        });
    });
}
